module.exports = __webpack_public_path__ + "static/media/GI.2e672bcf.png";